import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Skeleton } from '../components/ui/skeleton';
import { BookOpen } from 'lucide-react';
import { apiUrl } from '../config/api';
import { consumePendingLibraryAdd } from './AddToLibrary';

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setTeacherFromOAuth } = useAuth();

  useEffect(() => {
    async function handleCallback() {
      try {
        // Get session from Better Auth after OAuth redirect
        const response = await fetch(apiUrl('/api/auth/sso/get-session'), {
          credentials: 'include', // Include cookies
        });

        if (response.ok) {
          const session = await response.json();

          if (session && session.user) {
            // Store teacher OAuth session in our AuthContext
            await setTeacherFromOAuth(session);

            // If the user was sent here by a share link, finish that flow first
            const pendingBookId = consumePendingLibraryAdd();
            navigate(pendingBookId ? `/add/${pendingBookId}` : '/home');
          } else {
            throw new Error('No session found');
          }
        } else {
          throw new Error('Failed to get session');
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        // Redirect to login on error
        navigate('/login?error=oauth_failed');
      }
    }

    handleCallback();
  }, [navigate, setTeacherFromOAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/5 via-background to-primary/10">
      <div className="text-center space-y-4">
        <BookOpen className="h-16 w-16 mx-auto text-primary animate-pulse" />
        <h2 className="text-2xl font-semibold">Signing you in...</h2>
        <p className="text-muted-foreground">Please wait while we complete your authentication</p>
        <div className="flex justify-center space-x-2">
          <Skeleton className="h-3 w-3 rounded-full" />
          <Skeleton className="h-3 w-3 rounded-full" />
          <Skeleton className="h-3 w-3 rounded-full" />
        </div>
      </div>
    </div>
  );
}
